import React from 'react';
import { connect } from 'react-redux';
import ApiVoucher from '../../../../api/open-voucher';
import IndexProductos from './producto/index-productos';
import Commons from '../../../../commons/commons';
import './voucher.css';

class Voucher extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedIndex: 0,
      productos: [],
      loadingProducts: true,
    };
    this.handleChangeNights = this.handleChangeNights.bind(this);
  }

  componentDidMount() {
    const { voucherOptions, token } = this.props;
    if (voucherOptions) {
      ApiVoucher.getProductsByTypeVoucherId(voucherOptions[0].tipoVoucher.id, token).then((data) => {
        if (data.status) {
          const randomOrderProducts = data.object.default.sort(() => 0.5 - Math.random());
          this.setState({
            productos: randomOrderProducts,
            loadingProducts: false,
          });
        } else {
          this.setState({
            loadingProducts: false,
          });
        }
      });
    }
  }

  handleChangeNights(selectedIndex) {
    this.setState({ selectedIndex });
  }

  checkPayments = (promotionsList = []) => {
    const ahora12 = promotionsList.filter((promo) => promo.bank.denomination === 'AHORA 12')[0]; // if exist true, else false
    const ahora18 = promotionsList.filter((promo) => promo.bank.denomination === 'AHORA 18')[0]; // if exist true, else false
    return [ahora12, ahora18];
  }

  pricePerInstallments = (interests, price, installments) => {
    return (((price * interests) / 100) + price) / installments;
  }

  createSkeleton = () => {
    return (
      <div className='product-item'>
        <div className='header-product skeleton'>
          <h1 className='text-center'><span style={{ color: '#eaeaea' }}>&nbsp;</span></h1>
        </div>
        <div className='content-product'>
          <h2 className='text-center voucher-content-title'>
            <span style={{ color: '#eaeaea' }}>&nbsp;</span>
          </h2>
          <div className='row'>
            <IndexProductos data={null} />
          </div>

        </div>
      </div>
    );
  }

  render() {
    const { voucherOptions, promotions } = this.props;
    const { loadingProducts, productos, selectedIndex } = this.state;
    const [ahora12, ahora18] = this.checkPayments(promotions.promociones || []);

    if (!voucherOptions) return this.createSkeleton();
    const voucher = voucherOptions[selectedIndex];
    return (
      <div className='product-item'>
        <div className='header-product'>
          <div className='col-md-6 col-sm-12'>
            <div className='row'>
              <img
                src={voucher.tipoVoucher.imagenUrl}
                alt={voucher.tipoVoucher.descripcion}
                className='img-responsive img-mock'
              />
              <div className='clearfix' />
            </div>
          </div>
          <div className='col-md-6 col-sm-12'>
            <div className='row'>
              <div className='container-info'>
                <div className='col-md-7 col-sm-12'>
                  <div className='row'>
                    <div className='first-part text'>
                      <div className='info'>
                        <div className='product-title'>
                          <b>
                            Open Voucher
                            {voucher.tipoVoucher.descripcion}
                          </b>
                        </div>
                        <div className='aditional'>Elegí la cantidad de noches</div>
                        <div className='custom-select type'>
                          <div className='custom-caret' tabIndex='-1' />
                          <select
                            onChange={(e) => this.handleChangeNights(e.target.value)}
                            className='form-control type-selector'
                            name='noches'
                            value={selectedIndex}
                          >
                            {voucherOptions.map((voucher, index) => (
                              <option key={`${voucher.id}`} value={index}>
                                {voucher.usoVoucher.cantidadUsos}
                                {' '}
                                noches
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className='text'>
                          <span className='display-inline-block'>
                            <b>
                              Open Voucher
                              {voucher.tipoVoucher.descripcion}
                            </b>
                            {' '}
                            para
                            {' '}
                            <b>2 personas </b>
                          </span>
                          {' '}
                          para usar en distintos alojamientos cuando y como quieras
                        </div>
                      </div>
                      <div className='action in-middle'>
                        <div className='consulta'>
                          <a
                            target='_blank'
                            rel='noopener noreferrer'
                            href={`${process.env.RAZZLE_URL_PATH}/consulta`}
                            className='button-a color-dinamico-border-color-btn color-dinamico color-dinamico-border-color-btn-hover'
                          >
                            Consultar
                          </a>
                        </div>
                        <div className='ver-todo'>
                          <a
                            href={`${process.env.RAZZLE_URL_PATH}/open-voucher/productos/${voucher.tipoVoucher.id}/${voucher.id}`}
                            className='button-a'
                          >
                            Ver
                            {' '}
                            <span className='hide-mobile'>todos los</span>
                            {' '}
                            productos
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-md-5 col-sm-12'>
                  <div className='row'>
                    <div className='second-part'>
                      <div className='prod-price'>
                        <div className='value'>
                          <span className='currency'>{voucher.moneda.descripcion}</span>
                          {' '}
                          {Commons.numberToMoney(voucher.importe)}
                        </div>
                        <div className='static-text'>
                          Precio contado
                        </div>
                      </div>
                      <div className='action'>
                        <a
                          href={`${process.env.RAZZLE_URL_PATH}/open-voucher/checkout/${voucher.tipoVoucher.id}/${voucher.id}`}
                          className='button-a'
                          target='_black'
                          rel='noopener noreferrer'
                        >
                          Comprar
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-md-12'>
                  <div className='row'>
                    <div className='financing'>
                      {ahora12 && (
                        <div className='promotion'>
                          <div className='flex-container'>
                            <img
                              src='https://res.mundigea.com.ar/img/recursos/12.jpg'
                              className='img-promotion inline-block'
                              alt='Ahora 12'
                            />
                            <div className='text inline-block'>
                              <div className='title'>Cuotas de </div>
                              <div className='value'>
                                {voucher.moneda.descripcion}
                                {' '}
                                {
                                  Commons.numberFixedToMoney(
                                    this.pricePerInstallments(ahora12.interests, voucher.importe, ahora12.installments),
                                  )
                                }
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {ahora18 && (
                        <div className='promotion'>
                          <div className='flex-container'>
                            <img
                              src='https://res.mundigea.com.ar/img/recursos/18.jpg'
                              className='img-promotion inline-block'
                              alt='Ahora 18'
                            />
                            <div className='text inline-block'>
                              <div className='title'>Cuotas de </div>
                              <div className='value'>
                                {voucher.moneda.descripcion}
                                {' '}
                                {
                                  Commons.numberFixedToMoney(
                                    this.pricePerInstallments(ahora18.interests, voucher.importe, ahora18.installments),
                                  )
                                }
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='content-product'>
          <h2 className='text-center voucher-content-title'>
            Alojamientos disponible con tu Open Voucher
            {' '}
            {voucher.tipoVoucher.descripcion}
            <br />
            <b>Elegí uno o varios establecimientos y distribuí tus noches como quieras!</b>
          </h2>
          <div className='row'>
            {!loadingProducts && productos.length === 0 && (
              <>
                <br />
                <h2 className='text-center'>No hay contenido en este momento</h2>
              </>
            )}
          </div>
          {loadingProducts && (
          // SKELETON
            <IndexProductos
              uniqueId={`carousel-prods-${voucher.tipoVoucher.id}`}
              data={null}
            />
          )}
          {!loadingProducts && productos.length > 0 && (
            <IndexProductos
              fatherKey={voucher.id}
              uniqueId={`carousel-prods-${voucher.tipoVoucher.id}`}
              data={productos}
              voucherData={voucher}
            />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  token: state.applicationState.token,
  promotions: state.promociones,
});

export default connect(mapStateToProps, null)(Voucher);
